export const TEXTS = {
  COUPON_HEADER_TITLE: 'Coupons',
  COPY: 'Copy',
  COPY_CODE: 'Copy Code',
  OKAY: 'Okay',
  APPLY: 'Apply',
  APPLIED: 'APPLIED',
  VIEW_MORE: 'View More',
  VIEW_LESS: 'View Less',
  TERMS_AND_CONDITIONS: 'Terms & Conditions',
  APPLY_AND: 'Apply and ',
  SAVE: 'save ',
  CANCEL: 'Cancel',
  COUPON_SAVINGS: 'Coupon Savings',
  VIEW_BAG: 'View Bag',
  COUPONS_IMAGE: 'coupon Image',
  YOU_SAVED: 'You saved',
  REMOVE: 'Remove',
  DETAILS: ' see details',
  DISMISS: 'Dismiss',
  SAVE_OFFER: 'Save ',
  BACK: 'Back',
  VIEW_PRODUCTS: 'View Products',
};

export const APPLICABLE_COUPONS_PROPS = {
  title: 'Ready to Apply',
  subtitle: 'Apply one of these Coupons to save extra',
  key: 'Ready to Apply',
  className: 'couponsRendered',
  disabled: false,
};

export const NON_APPLICABLE_COUPONS_PROPS = {
  title: 'Shop More to Apply ',
  subtitle: 'Almost there! Shop more to save extra',
  key: 'Non Applicable Coupons',
  className: 'couponsRendered',
  disabled: false,
  showViewProduct: true,
  isCartCouponPage: true,
};

export const REMOVE_AND_APPLY_COUPONS_PROPS = {
  actionName: 'Remove and Apply',
  title: 'Remove and Apply',
  subtitle: 'Are you sure you want to remove <old> and apply <new>',
};

export const REMOVE_COUPON_PROPS = {
  actionName: 'Remove',
  title: 'Remove Coupon',
  subtitle: 'If you remove the Coupon, you will lose out on the offer applied too',
};

export const EMPTY_PAGE = {
  title: 'Uh-Oh!',
  subtitle: 'You seem to have no Coupons. Please try again after some time.',
  actionName: 'Ok, Got it',
};

export const EMPTY_PAYMENT_OFFERS_PAGE = {
  title: 'Uh-Oh!',
  subtitle: "You don't have active payment offers",
  actionName: 'Ok, Got it',
};

export const ERROR_PAGE = {
  title: 'Something went wrong',
  subtitle: 'Oops! Something seems broken here. Come back later & try again.',
  actionName: 'Try Again',
};

export const BUTTON_TYPE = {
  APPLY: 'apply',
  COPY: 'copy',
};

export const COUPON_CODE_COPIED_TEXT = {
  SUCCESS: 'Coupon code copied successfully',
  FAILED: 'Copying coupon code failed!',
};

export const EMPTY_COUPON_DATA = {
  couponCode: '',
  couponId: -1,
  title: '',
  subTitle: '',
  description: '',
  couponTncUrl: '',
  freebies: [],
  imageUrl: '',
  prive: false,
  subtitle: '',
  tnc: [],
  discount: -1,
  disabled: false,
};

export const LOGIN_BANNER_IMAGE_ALT = 'Login Banner Image';
export const COUPON_LOCK_ICON_URL =
  'https://images-static.nykaa.com/fashion-images/pub/media/fashion-images/privacy-policy.png';
export const COUPON_EXPIRY_REMOTE_CONFIG = 'couponExpiry';

export const ARIA_LABELS = {
  CLOSE_COUPON_DETAILS: 'Close coupon details',
  GO_BACK: 'Go back',
  DISMISS_COUPON_DETAILS: 'Dismiss coupon details',
  CLOSE_OFFER_DETAILS: 'Close offer details',
  APPLY_COUPON: 'Apply',
  COPY_COUPON_CODE: (couponCode: string) => `Copy coupon code ${couponCode}`,
};

export const COUPON_DELTA_EXPERIMENT = 'coupon-delta-communication';
export const COUPON_DELTA_EXPERIMENT_EXP = {
  COUPON_DELTA_EXPERIMENT_EXP_A: 'coupon-delta-communication-a',
  COUPON_DELTA_EXPERIMENT_EXP_B: 'coupon-delta-communication-b',
};

export const PLP_REDIRECT_URL = '/op';

export enum COUPON_CLICK_LOCATION_TYPE {
  PDP_COUPONS_WIDGET_DELTA = 'pdp_coupons_widget_delta',
  PDP_COUPONS_WIDGET_SEE_DETAILS = 'pdp_coupons_widget_see_details',
  PDP_OFFERS_WIDGET_DELTA = 'pdp_offers_widget_delta',
  PDP_OFFERS_WIDGET_SEE_DETAILS = 'pdp_offers_widget_see_details',
  CART_OFFERS_WIDGET = 'cart_offers_widget',
  COUPONS_PAGE_WIDGET_DELTA = 'coupons_page_widget_delta',
  COUPONS_PAGE_WIDGET_SEE_DETAILS = 'coupons_page_widget_see_details',
  MYCOUPONS_PAGE = 'mycoupons_page',
}
